import { useState } from "react"
import Video from "../../components/Video/Video"
import Container from "../../components/utils/Container"

import VideoThumb1 from '../../assets/images/video1.png'
import VideoThumb2 from '../../assets/images/video2.png'

const Videos = () => {

	const [videos] = useState([
		{
			thumbnail: VideoThumb1,
			title: 'Phoria Girl 9000',
			date: '7/5 3:30pm',
			duration: '3:12',
			price: '$10',
		},
		{
			thumbnail: VideoThumb2,
			title: 'CuteChick93',
			date: '7/5 3:30pm',
			duration: '3:12',
			price: '$10',
		},
		{
			thumbnail: VideoThumb1,
			title: 'Phoria Girl 9000',
			date: '7/5 3:30pm',
			duration: '3:12',
			price: '$10',
		},
		{
			thumbnail: VideoThumb2,
			title: 'CuteChick93',
			date: '7/5 3:30pm',
			duration: '3:12',
			price: '$10',
		},
		{
			thumbnail: VideoThumb1,
			title: 'Phoria Girl 9000',
			date: '7/5 3:30pm',
			duration: '3:12',
			price: '$10',
		},
		{
			thumbnail: VideoThumb2,
			title: 'CuteChick93',
			date: '7/5 3:30pm',
			duration: '3:12',
			price: '$10',
		},
		{
			thumbnail: VideoThumb1,
			title: 'Phoria Girl 9000',
			date: '7/5 3:30pm',
			duration: '3:12',
			price: '$10',
		},
		{
			thumbnail: VideoThumb2,
			title: 'CuteChick93',
			date: '7/5 3:30pm',
			duration: '3:12',
			price: '$10',
		}
	])

	return (
		<div className="videos bg-secondary">
			<Container>
				<div className="py-3 lg:py-12 font-bold text-xl lg:text-2xl 2xl:text-2xl">
					<h4>Video Feed</h4>
				</div>
				<div
					className="grid gap-3 sm:gap-5 md:gap-8 2xl:gap-12 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 pb-12"
				>
					{videos.map((video, vI) => (
						<Video video={video} key={vI} />
					))}
				</div>
			</Container>
		</div>
	)
}

export default Videos